module.exports = __webpack_public_path__ + "static/img/19.d1848a0f.jpg";